import { useState } from "react";
import { FiInfo } from "react-icons/fi";
import CircularScore from "../../../../../components/CircularScore";
import AlertsModal from "../../modals/AlertsModal";
import { cn } from "../../../../../lib/utils";
const Alerts = ({ alerts }) => {
  const [isOpen, setIsOpen] = useState(false);

  const [details, setDetails] = useState(null);

  return (
    <div>
      <div className="overflow-x-auto">
        <div className="w-full border min-w-[1100px] border-neutral300 rounded-lg text-sm">
          <div className="flex justify-between gap-4 text-left px-3 xl:px-6 py-2 bg-neutral3 rounded-t-lg border-b text-neutral700 font-medium w-full">
            <span className="w-[25%] mr-12">Alert</span>
            <span className="w-[20%]">URL</span>
            <span className="w-[10%]">Severity</span>
            <span className="flex-1">Risk</span>
            <span className="flex-1">Confidence</span>
            <span className="flex-1 text-left">CWE ID</span>
            <span className="w-[5%] text-right"></span>
          </div>

          {alerts?.map((item, index) => {
            return (
              <div
                key={index}
                className={`min-h-[60px] py-2 px-3 xl:px-6 flex gap-4 text-neutral900 items-center ${
                  index === 0 ? "border-t-0" : "border-t border-t-[#EAECF0]"
                } hover:bg-[#F9FAFB]`}
              >
                <div className="w-[25%] text-left mr-12 font-medium">
                  {item?.name ?? "-"}
                </div>
                <div className="w-[20%] text-left">
                  <p className="w-fit max-w-[200px] px-2 py-1 rounded-full bg-neutral200 truncate">{item?.url}</p>
                </div>
                <div className="w-[10%]">
                  {item?.riskAsFloat ? (
                    <CircularScore score={item?.riskAsFloat} />
                  ) : item?.riskAsFloat === 0 ? (
                    <CircularScore score={0} />
                  ) : (
                    <CircularScore staticScore={0} />
                  )}
                </div>
                <div className="flex-1 text-left">
                  <p>{item?.risk}</p>
                  </div>
                <div className="flex-1 text-left">
                  <p
                    className={cn(
                      item?.confidence === "Low" &&
                        "border-[#00C8511A] text-success100 bg-success10",
                      item?.confidence === "Medium" &&
                        "border-cream100 text-brown100 bg-[#FFBB331A]",
                      item?.confidence === "High" &&
                        "border-[#F973161A] text-[#E3650F] bg-[#F973161A]",
                      item?.confidence === "Critical" &&
                        "border-[#FFC1C1] text-[#E12A5B] bg-[#FF44441A]",
                      " border-[1.5px] rounded-full w-fit px-2 py-1"
                    )}
                  >
                    {item?.confidence}
                  </p>
                </div>
                <div className="flex-1 text-left">{item?.cweid}</div>
                <div className="w-[5%] flex justify-center">
                  <FiInfo
                    className="text-blue-600 cursor-pointer"
                    onClick={() => {
                      setDetails(item);
                      setIsOpen(true);
                    }}
                  />
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <AlertsModal isOpen={isOpen} setIsOpen={setIsOpen} details={details} />
    </div>
  );
};

export default Alerts;
